// LLSEOMeta.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const LLSEOMeta = ({ 
  title, 
  description, 
  keywords,
  canonicalPath = '/',
  ogImage = '/og-default.jpg'
}) => {
  const siteUrl = 'https://yourdomain.com'; // replace with your real domain
  const canonical = `${siteUrl}${canonicalPath}`;

  return (
    <Helmet>
      <title>{title} | LoopholeLaw</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={`${title} | LoopholeLaw`} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${title} | LoopholeLaw`} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />
    </Helmet>
  );
};

export default LLSEOMeta;